import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// import scriptLoader from 'react-async-script-loader'

import RaisedButton from 'material-ui/RaisedButton';
// import DatePicker from 'material-ui/DatePicker';
import AutoComplete from 'material-ui/AutoComplete';
import TextField from 'material-ui/TextField';
import LinearProgress from 'material-ui/LinearProgress';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Toggle from 'material-ui/Toggle';

// import moment from 'moment';

import InfiniteScroll from 'react-infinite-scroller';
import RefreshIndicator from 'material-ui/RefreshIndicator';

import { EditorState, convertToRaw, ContentState, Modifier } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { BlockPicker } from 'react-color';

import Note from './Note';
import Upload from './Upload';
import Drop from './Drop';

import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';


import './Notes.css';





const loaderStyle = {
  position: 'relative',
  top: '90%',
  left: '50%',
  transform: `translate(-50%, -50%)`
};

const descriptionStyle = {
    float: 'left',
    width: '100%'
};


const tagsStyle = {
    float: 'left',
    width: '25%'
};

const taskStyle = {
    float: 'left',
    width: '75%'
};

const typeStyle = {
    float: 'left',
    width: '25%',
    marginTop: '24px'
};

const addButtonStyle = {
    float: 'left',
    minWidth: '30px',
    marginTop: '30px',
    // marginLeft: '20px',
    boxShadow: 'none'
};

const filterButtonStyle = {
    float: 'left',
    minWidth: '30px',
    marginTop: '30px',
    marginRight: '20px',
    boxShadow: 'none'
};

const taskDataSourceConfig = {
  text: 'fullname',
  value: 'id'
};

const typeDataSourceConfig = {
  text: 'name',
  value: 'id'
};











class Notes extends Component {

    state = {
        tasks: [],
        types: [],
        loadingNotes: false,
        memories: [],
        hasMoreNotes: true,
        currentPage: 0,
        loadingAdd: false,
        type: null,
        task: null,
        tags: '',
        description: '',

        uploads: [],

        filterShow: false,
        filterTask: null,
        filterType: null,
        filterDescription: '',

        editorState: EditorState.createEmpty(),

    };



    componentDidMount() {
        var that = this;

        window.addEventListener("paste", function(e){

            if(e.clipboardData == false){
                return false;
            };

            var items = e.clipboardData.items;
            if(items == undefined){
                return false;
            };

            for (var i = 0; i < items.length; i++) {
                if (items[i].type.indexOf("image") == -1) continue;

                var blob = items[i].getAsFile();

                that.setState(prevState => ({
                    uploads: [...prevState.uploads, blob]
                }))

            }

        }, false);


        axios
        .get('user/tasks')
        .then(res => {

            res.data.tasks.map((object) => {
                 // object.fullname = '&lt;strong&gt;' + object.project.client.name.toUpperCase() + '&lt;/strong&gt;' + ',  ' + object.project.name + '  (' + object.name + ')';
                 object.fullname = object.project.client.name + '.  ' + object.project.name + '  (' + object.name + ')';
            });

            this.setState({ tasks: res.data.tasks })

        })
        .catch(err => console.log(err))



        axios
        .get('list/memory-types')
        .then(res => {
            this.setState({ types: res.data.types })

            this.setState({ type: res.data.types[0].id })
        })
        .catch(err => console.log(err))

    }



    handleDrop = (files) => {
      // var data = new FormData();
      var that = this;

      files.forEach((file, index) => {

        // data.append('file' + index, file);

        console.log(file);

        that.setState(prevState => ({
            uploads: [...prevState.uploads, file]
        }))


      });

      // console.log(data)

      // fetch('/upload', {
      //   method: 'POST',
      //   body: data
      // });
    }




    uploadRemove = (target) => {

        this.setState({
            uploads: this.state.uploads.filter((_, i) => _.lastModified !== target.props.id)
        });

    }


    descriptionHandleChange = (event, value) => {
        this.setState({description: value});
    }

    tagsHandleChange = (event, value) => {
        this.setState({tags: value});
    }

    taskHandleChange = (chosenRequest, index) => {
        this.setState({task: chosenRequest.id});
        this.refs.descriptionField.focus();
    }


    filterTaskChange = (chosenRequest, index) => {
        this.setState({filterTask: chosenRequest.id});
    }

    filterTypeChange = (event, index, value) => {
        this.setState({filterType: value})
    }

    filterDescriptionHandleChange = (event, value) => {
        this.setState({filterDescription: value});
    }

    filterClearHandle = () => {
        this.setState({
            filterTask: null,
            filterType: null,
            filterDescription: ''
        });
        this.filterHandle()
    }

    filterHandle = () => {
        this.setState({currentPage: 0});
        this.setState({ memories: [] })
        this.loadNotes(0);
    }



    handleNoteDelete = (target) => {

        // axios
        // .post('user/memories/delete',{
        //      id: target.props.id
        //  })
        // .then(res => {
        //      console.log(res)

        //      this.setState({
        //          memories: this.state.memories.filter((_, i) => _.id !== target.props.id)
        //      });

        //  })
        // .catch(err => console.log(err));

    };

    loadNotes(page) {
        var that = this;

        setTimeout(function() { // timeout para que no intente cargar misma pagina varias veces en el no-bounce infinite scroll

            if(that.state.loadingNotes){
                return false;
            }
            that.setState({loadingNotes: true});

            var newpage = that.state.currentPage + 1;
            that.setState({currentPage: newpage});


            var data = {
                page: that.state.currentPage,
            };


            if(that.state.filterTask){
                data.task = that.state.filterTask;
            }
            if(that.state.filterType){
                data.type = that.state.filterType;
            }
            if(that.state.filterDescription){
                data.description = that.state.filterDescription;
            }



            axios
            .post('user/memories', data)
            .then(res => {

                that.setState({ memories: that.state.memories.concat(res.data.memories.data) })


                if(res.data.memories.to === null){
                    console.log('STOP');
                    that.setState({hasMoreNotes: false});
                }

                that.setState({loadingNotes: false});

            })
            .catch(err => console.log(err))

        }, 500);


    }


    descriptionHandleKey = (ev) => {
        if (ev.key === 'Enter' && (ev.shiftKey || ev.ctrlKey)) {
            this.addHandle();
            ev.preventDefault();
        }
    }


    submitAdd = (ev) => {
        if (ev.key === 'Enter') {
            this.addHandle();
            ev.preventDefault();
        }
    }


    addHandle = () => {
        // var that = this;

        this.setState({loadingAdd : true});

        ////////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////


        const data = new FormData();

        // data.append('action', 'ADD');
        // data.append('param', 0);

        this.state.uploads.forEach(function(item,index){
            console.log(item);

            // data.append('files[]', new Blob(['test payload'], { type: 'text/csv' }), 'screeeen' + index);

            data.append('files[]', item, 'userupload' + index);

        });

        data.append('description', this.state.description);
        data.append('tags', this.state.tags);
        data.append('task', this.state.task);
        data.append('type', this.state.type);

        // axios.post('http://httpbin.org/post', data);

        // return false;

        ////////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////


        axios
        .post('user/memories/new',data)
        .then(res => {
            console.log(res)

            this.setState({ memories: [res.data.memory, ...this.state.memories] })

            this.setState({
                            loadingAdd : false,
                            description : '',
                            tags : '',
                            uploads: []
                        });

            this.refs.descriptionField.focus();



        })
        .catch(err => console.log(err))

    }

    typeChange = (event, index, value) => this.setState({type: value})


    toggleFilters = (event, isInputChecked) => this.setState({filtersShow: isInputChecked});



    typeItems(types) {
        return types.map((type) => (
          <MenuItem
            key={type.id}
            insetChildren={true}
            checked={this.state.type === type.id}
            value={type.id}
            primaryText={type.name}
          />
        ));
    }



    onEditorStateChange: Function = (editorState) => {
        this.setState({
            editorState,
        });
    };




    uploadImageCallBack(file) {
      return new Promise(
        (resolve, reject) => {

          const xhr = new XMLHttpRequest();
                  xhr.open('POST', 'https://api.imgur.com/3/image');
                  xhr.setRequestHeader('Authorization', 'Client-ID XXXXX');

          const data = new FormData();
                data.append('image', file);

          xhr.send(data);
          xhr.addEventListener('load', () => {
            const response = JSON.parse(xhr.responseText);
            resolve(response);
          });

          xhr.addEventListener('error', () => {
            const error = JSON.parse(xhr.responseText);
            reject(error);
          });

        }
      );
    }



    render() {

        const { editorState } = this.state;

        const { loadingNotes, loadingAdd, tags, task, tasks, type, types, description, filtersShow, filterTask, filterType, filterDescription } = this.state;

        var memories = [];
        this.state.memories.map((object, i) => {

            let newDay = (i===0 || object.date !== this.state.memories[i-1].date) ? true : false;

            memories.push(
                <Note key={object.id} id={object.id} item={object} newDay={newDay} onClick={this.handleNoteClick} onDelete={this.handleNoteDelete} />
            );

        });


        var uploads = [];
        this.state.uploads.map((object, i) => {

            uploads.push(
                <Upload key={object.lastModified} id={object.lastModified} item={object} onDelete={this.uploadRemove} />
            );

        });


        let goodToGo = description.length>0&&task!=null&&type!=null?true:false;

        return (
            <div className="notes">

                <div className="welcome">
                    <div className="wrapper">
                        <h1>Notas</h1>
                    </div>
                </div>

                <div className="add-frame">
                    <div className="wrapper">

                        <AutoComplete
                            floatingLabelText="Proyecto"
                            filter={AutoComplete.fuzzyFilter}
                            dataSource={tasks}
                            maxSearchResults={8}
                            dataSourceConfig={taskDataSourceConfig}
                            openOnFocus={false}
                            onNewRequest={this.taskHandleChange}
                            value={task}
                            className="task-field"
                            style={taskStyle}
                            menuStyle={{width: 420}}
                            listStyle={{width: 420}}
                            ref="taskField"
                            autoFocus
                        />

                        <SelectField
                            hintText="Tipo"
                            value={type}
                            onChange={this.typeChange}
                            style={typeStyle}
                            className="type-field"
                            ref="typeField"
                          >
                            {this.typeItems(types)}
                        </SelectField>

                        <TextField
                            hintText="Para enviar: Shift + Enter"
                            floatingLabelText="Qué?"
                            onChange={this.descriptionHandleChange}
                            className="description-field"
                            style={descriptionStyle}
                            onKeyPress={this.descriptionHandleKey}
                            value={description}
                            ref="descriptionField"
                            multiLine={true}
                            rows={1}
                        />

                        <Editor
                            editorState={editorState}
                            wrapperClassName="demo-wrapper"
                            editorClassName="demo-editor"
                            onEditorStateChange={this.onEditorStateChange}
                            toolbarCustomButtons={[<CustomOption />]}
                            mention={{
                                  separator: ' ',
                                  trigger: '@',
                                  suggestions: [
                                    { text: 'APPLE', value: 'apple', url: 'apple' },
                                    { text: 'BANANA', value: 'banana', url: 'banana' },
                                    { text: 'CHERRY', value: 'cherry', url: 'cherry' },
                                    { text: 'DURIAN', value: 'durian', url: 'durian' },
                                    { text: 'EGGFRUIT', value: 'eggfruit', url: 'eggfruit' },
                                    { text: 'FIG', value: 'fig', url: 'fig' },
                                    { text: 'GRAPEFRUIT', value: 'grapefruit', url: 'grapefruit' },
                                    { text: 'HONEYDEW', value: 'honeydew', url: 'honeydew' },
                                  ],
                            }}
                            hashtag={{}}
                            toolbar={{
                                  inline: { inDropdown: false },
                                  list: { inDropdown: false },
                                  textAlign: { inDropdown: false },
                                  link: { inDropdown: false },
                                  history: { inDropdown: false },
                                  image: { uploadCallback: this.uploadImageCallBack, alt: { present: true, mandatory: true } },
                                  colorPicker: { component: ColorPic }
                            }}
                            localization={{
                                  locale: 'es',
                            }}
                        />
                        <textarea
                            disabled
                            value={draftToHtml(convertToRaw(editorState.getCurrentContent()))}
                        />

                        <Drop className="attachs" onDrop={ this.handleDrop } >
                          {uploads.length>0?uploads:<span className="empty">Pegá capturas de pantalla o arrastrá archivos</span>}
                        </Drop>

                        <RaisedButton
                            label="Agregar"
                            primary={true}
                            onClick={this.addHandle}
                            className="add-field"
                            style={addButtonStyle}
                            disabled={!goodToGo}
                        />

                    </div>
                </div>

                <div className="filter-toggle">
                    <div className="wrapper">
                        <Toggle
                            label=""
                            onToggle={this.toggleFilters}
                            style={{width: '100px', position: 'relative', left: '-13px'}}
                        />
                    </div>
                </div>

                {filtersShow&&
                <div className="filter-frame">
                    <div className="wrapper">

                        <AutoComplete
                            floatingLabelText="Proyecto"
                            filter={AutoComplete.fuzzyFilter}
                            dataSource={tasks}
                            maxSearchResults={8}
                            dataSourceConfig={taskDataSourceConfig}
                            openOnFocus={false}
                            onNewRequest={this.filterTaskChange}
                            value={filterTask}
                            className="task-field"
                            style={taskStyle}
                            menuStyle={{width: 420}}
                            listStyle={{width: 420}}
                            ref="filterTaskField"
                        />

                        <SelectField
                            hintText="Tipo"
                            value={filterType}
                            onChange={this.filterTypeChange}
                            style={typeStyle}
                            className="type-field"
                            ref="filterTypeField"
                            multiple={true}
                          >
                            {this.typeItems(types)}
                        </SelectField>

                        <TextField
                            hintText="Para enviar: Shift + Enter"
                            floatingLabelText="Qué?"
                            onChange={this.filterDescriptionHandleChange}
                            className="description-field"
                            style={descriptionStyle}
                            value={filterDescription}
                            ref="filterDescriptionField"
                            multiLine={true}
                            rows={1}
                        />

                        <RaisedButton
                            label="Buscar"
                            primary={true}
                            onClick={this.filterHandle}
                            className="submit-field"
                            style={filterButtonStyle}
                        />

                        <RaisedButton
                            label="Limpiar"
                            primary={true}
                            onClick={this.filterClearHandle}
                            className="submit-field"
                            style={filterButtonStyle}
                        />

                    </div>
                </div>
                }

                <div className="results">

                    <div className="wrapper">

                        <InfiniteScroll
                            pageStart={0}
                            loadMore={this.loadNotes.bind(this)}
                            hasMore={this.state.hasMoreNotes}
                            loader={null}
                        >

                            <div className="list">

                                {loadingAdd &&
                                <div className="item ghost">
                                    <LinearProgress mode="indeterminate" />
                                </div>}

                                {memories}
                            </div>

                        </InfiniteScroll>

                    </div>

                    {loadingNotes &&
                      <div className="loading">
                          <RefreshIndicator
                               size={40}
                               left={10}
                               top={0}
                               status="loading"
                               className="loader"
                               style={loaderStyle}
                          />
                      </div>}

                </div>

            </div>
        );

    }


}



class CustomOption extends Component {
    static propTypes = {
        onChange: PropTypes.func,
        editorState: PropTypes.object,
    };

    addStar: Function = (): void => {

        const { editorState, onChange } = this.props;

        const contentState = Modifier.replaceText(
            editorState.getCurrentContent(),
            editorState.getSelection(),
            '⭐',
            editorState.getCurrentInlineStyle(),
        );

        onChange(EditorState.push(editorState, contentState, 'insert-characters'));

    };

    render() {
        return (
            <div onClick={this.addStar}>⭐</div>
        );
    }

}



class ColorPic extends Component {
    static propTypes = {
        expanded: PropTypes.bool,
        onExpandEvent: PropTypes.func,
        onChange: PropTypes.func,
        currentState: PropTypes.object,
    };

    stopPropagation = (event) => {
        event.stopPropagation();
    };

    onChange = (color) => {
        const { onChange } = this.props;
        onChange('color', color.hex);
    }

    renderModal = () => {

        const { color } = this.props.currentState;

        return (
            <div onClick={this.stopPropagation}>
                <BlockPicker
                    color={color}
                    onChangeComplete={this.onChange}
                />
            </div>
        );

    };

    render() {

        const { expanded, onExpandEvent } = this.props;

        return (
            <div
                aria-haspopup="true"
                aria-expanded={expanded}
                aria-label="rdw-color-picker"
            >
                <div onClick={onExpandEvent}>
                    <h4>COL</h4>
                </div>
                {expanded ? this.renderModal() : undefined}
            </div>
        );

    }
}






const mapStateToProps = (state, ownProps) => ({
  auth: state.auth_reducer
});

const AppContainer = connect(
  mapStateToProps
)(Notes);


export default AppContainer;


// WEBPACK FOOTER //
// ./src/modules/notes/Notes.js